import { Injectable } from '@angular/core';
import { resource } from '@util/resource';
import { WineryInfo } from '@interfaces/dws/winery-info';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WineryParametersService {
  constructor() { }

  updateGiftWineryParameters(wineryId: string, data: WineryInfo.WineryParameter): Observable<unknown> {
    return resource('crm://winery/wineryId/parameters/gift-duration')
      .params({ wineryId })
      .post(data);
  }

  updateActiveBillingDetails(wineryId: string, value: boolean): Observable<unknown> {
    return resource('crm://winery/wineryId/parameters/active-billing-details')
      .params({ wineryId })
      .post({ value: String(value) });
  }

  setWineryParameter(wineryId: string, data: WineryInfo.WineryParameter): Observable<unknown> {
    return resource('crm://winery/wineryId/parameters')
      .params({ wineryId })
      .post(data);
  }

  getWineryParameterByKey(wineryId: string, key: string): Observable<WineryInfo.WineryParameter> {
    return resource('crm://winery/wineryId/parameters/key')
      .params({ wineryId, key })
      .get<WineryInfo.WineryParameter>();
  }
}
